import React, { Component }          from 'react';

import axios                         from 'axios';
import Login                         from '../login/Login';
import "./Home.scss";
import ForgotPassword                from '../forgot-password/ForgotPassword';
import Dashboard                     from '../dashboard/Dashboard';
import Network                       from '../common/Network';

const UPDATE_SESSION_INTERVAL_MS = 1000 * 60 * 5;

export const STATES = {
  LOGIN: "LOGIN",
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
  DASHBOARD: "DASHBOARD",
}

class Home extends Component {

  constructor(props) {
    super(props);

    this.state            = {
      currentState: null,
      role: "",
    }
    this.updateSessionInterval = 0;
  }

  componentDidMount() {
    this.updateSession();
    this.startUpdateSessionInterval();
  }

  updateSession() {
    Network.getSession().then(response => {
      if (response.data && response.data.session) {
        if (response.data.session["role"]) {
          Network.refreshSession();
          this.setState({currentState: STATES.DASHBOARD, role: response.data.session["role"]})
        } else {
          this.setState({currentState: STATES.LOGIN})
        }
      }
    });
  }

  startUpdateSessionInterval() {
    clearInterval(this.updateSessionInterval);
    this.updateSessionInterval = setInterval(() => {
      Network.refreshSession();
    }, UPDATE_SESSION_INTERVAL_MS)
  }

  componentWillUnmount() {
    clearInterval(this.updateSessionInterval);
  }

  forgotPassword() {
    this.setState({currentState: STATES.FORGOT_PASSWORD})
  }

  navigateTo(fromState, newState) {
    if (fromState === STATES.LOGIN) {
      this.updateSession();
    }

    if (STATES[newState]) {
      this.setState({currentState: newState})
    }
  }

  render() {
    return (
      <div className="home__container">
        <Login
          navigateTo={(endpoint) => this.navigateTo(STATES.LOGIN, endpoint)}
          forgotPassword={this.forgotPassword.bind(this)}
          currentState={this.state.currentState} />
        <ForgotPassword
          navigateTo={(endpoint) => this.navigateTo(STATES.FORGOT_PASSWORD, endpoint)}
          currentState={this.state.currentState} />
        <Dashboard
          role={this.state.role}
          navigateTo={(endpoint) => this.navigateTo(STATES.DASHBOARD, endpoint)}
          currentState={this.state.currentState} />
      </div>
    );
  }
}

export default Home;